import { CustomerContact } from '@/modules/contacts/shared/domain/customer-contact';
import { CustomersPagination } from '@/modules/customers/domain/customers-pagination';
import { HttpRepository } from '@/modules/shared/shared/domain/repositories/http.repository';

class CustomersRepository extends HttpRepository {
    private static readonly RESOURCE = 'customers';

    /**
     * Con esta petición se obtienen los informes de salud del cliente
     * que está en línea mediante su id y la fecha mediante la cual
     * desea obtener el informe.
     *
     * @param id id del cliente
     * @param date fecha del informe
     */
    getHealthReport(id: number, date: string) {
        return this.get(
            this.createUri([`${CustomersRepository.RESOURCE}`, id, 'reports', date]),
            this.createAuthorizationDocumentsHeader(),
        );
    }

    /**
     * Con esta petición se obtienen las facturas del cliente que está
     * en línea mediante su id y la fecha mediante la cual desea obtener
     * la factura.
     *
     * @param id id del cliente
     * @param date fecha de la factura
     */
    getInvoice(id: number, date: string) {
        return this.get(
            this.createUri([`${CustomersRepository.RESOURCE}`, id, 'invoices', date]),
            this.createAuthorizationDocumentsHeader(),
        );
    }

    async getDirectoryContacts(idCustomer: number): Promise<CustomerContact[]> {
        return (
            await this.get(
                `${CustomersRepository.RESOURCE}/${idCustomer}/admin-users`,
                this.createAuthorizationHeader(),
            )
        ).data;
    }

    async getCustomers(customersOptions: {
        limit: number;
        start: number;
        keyword: string;
        cav: boolean;
    }): Promise<CustomersPagination> {
        return (
            await this.get(
                `${CustomersRepository.RESOURCE}?limit=${customersOptions.limit}&start=${
                    customersOptions.start
                }&keyword=${customersOptions.keyword}${customersOptions.cav ? '&cav=true' : ''}`,
                this.createAuthorizationHeader(),
            )
        ).data;
    }
}
const customersRepository = new CustomersRepository();
export default customersRepository;
